import React from 'react';
// import { Toaster } from "react-hot-toast";
import { ToastContainer } from "react-toastify";

import Navbar from "./components/Navbar/Navbar";
import Sidebar from "./components/Sidebar/Sidebar";
import Dashboard from "./components/Dashboard/Dashboard";
import { useAdminAuth } from "./context/AdminAuthContext";
import { ColorRing } from "react-loader-spinner";
import './App.css';
import { AllRoutes } from './Pages/AllRoutes/AllRoutes';

function App() {
  const { loading } = useAdminAuth();
  const token = localStorage.getItem("admintoken");

  // Show loader while authentication is in progress
  if (loading) {
    return (
      <div className="centered-container">
        <ColorRing
          visible={true}
          height="80"
          width="80"
          ariaLabel="color-ring-loading"
          colors={["#b0b2f6", "#9296f3", "#6d71f6", "#484ef6", "#272ef7"]}
        />
      </div>
    );
  }

  // If token exists, show dashboard
  if (token) {
    return (
      <div className="App">
        {/* <Toaster
          position="top-right"
          containerStyle={{
            marginTop: "50px",
            zIndex: 100000,
          }}
          toastOptions={{
            style: { zIndex: 100000 },
          }}
        /> */}

<ToastContainer
  style={{ zIndex: 9999999, marginTop: "60px" }}
  position="top-right"
  autoClose={3000}
  hideProgressBar={false}
  closeOnClick
  rtl={false}
  pauseOnFocusLoss
  draggable
  pauseOnHover
  newestOnTop
/>







        <Navbar />
        <div className='sidebar-dashboard-container'>
          <Sidebar />
          <div className='dashboard-container'>
            <Dashboard />
          </div>
        </div>
      </div>
    );


  }

  return (
    <div className="App">
      <ToastContainer
        style={{ zIndex: 9999999, marginTop: "60px" }}
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        newestOnTop
      />

      <AllRoutes />
    </div>
  );
}

export default App;
